const ADD_OR_UPDATE_DOWNLOAD_REQUEST = 'downloadRequests/ADD_OR_UPDATE_DOWNLOAD_REQUEST'
const REPLACE_DOWNLOAD_REQUESTS = 'downloadRequests/REPLACE_DOWNLOAD_REQUESTS'
const REMOVE_DOWNLOAD_REQUEST = 'downloadRequests/REMOVE_DOWNLOAD_REQUEST'

export function addOrUpdateDownloadRequest(request) {
  return { type: ADD_OR_UPDATE_DOWNLOAD_REQUEST, payload: request }
}

export function replaceDownloadRequests(requests) {
  return { type: REPLACE_DOWNLOAD_REQUESTS, payload: requests }
}

export function removeDownloadRequest(id) {
  return { type: REMOVE_DOWNLOAD_REQUEST, payload: id }
}

export const initialState = []

export default function downloadRequests(state = initialState, action = {}) {
  switch (action.type) {
    case ADD_OR_UPDATE_DOWNLOAD_REQUEST: {
      if (!action.payload || !action.payload.id) {
        return state
      }

      const existingIndex = state.findIndex(item => item.id === action.payload.id)
      if (existingIndex >= 0) {
        return state.map((item, index) => index === existingIndex ? { ...item, ...action.payload } : item)
      }

      return [action.payload, ...state]
    }

    case REPLACE_DOWNLOAD_REQUESTS: {
      if (!Array.isArray(action.payload)) {
        return state
      }

      return action.payload.filter(item => item && item.id)
    }

    case REMOVE_DOWNLOAD_REQUEST:
      return state.filter(item => item.id !== action.payload)

    default:
      return state
  }
}

export const selectors = {
  all: state => (state.downloadRequests || []),
}



// WEBPACK FOOTER //
// ./src/redux/downloadRequests.js